import { useEffect } from "react";

const GalleryEnhancer = () => {
  useEffect(() => {
    const images = document.querySelectorAll(".gallery img");

    images.forEach((img) => {
      img.addEventListener("click", function () {
        const modal = document.createElement("div");
        modal.style.position = "fixed";
        modal.style.top = "0";
        modal.style.left = "0";
        modal.style.width = "100vw";
        modal.style.height = "100vh";
        modal.style.background = "rgba(0, 0, 0, 0.8)";
        modal.style.display = "flex";
        modal.style.justifyContent = "center";
        modal.style.alignItems = "center";
        modal.style.cursor = "pointer";
        modal.style.zIndex = "1000";

        const imgClone = document.createElement("img");
        imgClone.src = this.src.replace(/(\?|&)w=\d+/, "$1280");
        imgClone.className = "gallery__img";

        modal.appendChild(imgClone);
        document.body.appendChild(modal);

        modal.addEventListener("click", () => modal.remove());
      });
    });

    return () => {
      images.forEach((img) => img.removeEventListener("click", () => {}));
    };
  }, []);

  return null; // No renderiza nada, solo agrega la funcionalidad
};

export default GalleryEnhancer;
